

import React, { useEffect, useState } from 'react';

import { DashboardLayout, GeneralTable, Button, SubmenuTooltip, MoreButton,
    ConfirmationModal, AlertMessage, Toaster, DateRangePicker } from "components";

import ic_email from 'assets/images/ic_send_email.svg';
import ic_delete_invoices from 'assets/images/ic_delete_invoices.svg';

import { func_validation, func_file, isObjectEmpty, getTotalCountFromHeader } from 'functions';
import { debitNoteColumns } from './debitNoteColumns';

import 'assets/scss/billingPortal/modules/debitNote.scss';
import { useAlertMessage, useDropdownList, 
    useUnpostedDebitNote, postedDebitNote, useDeleteDebitNote,
    usePendingKnockOff
} from './hooks';
import { Dropdown } from "components";
import { MultiFilters } from 'components/filters/MultiFilters';



export default function DebitNotePresentation(props) {
    const { 
        getDebitNoteList_requesting,
        isDebitNoteRecordUpdatedSuccessfully,
        debitNoteList, debitNoteListHeaders,
        history,

        knockOffCredit_requesting,
        postDebitNote_requesting
    } = props;
    
    // States
    let status = history?.location?.search?.substring("status".length + 2);
    const [currentTabId, setCurrentTabId] = useState(status? status:"unposted");
    const [selectedDebitNotes, setSelectedDebitNotes] = useState([]);
    const [isFilterReset, setIsFilterReset] = useState();

    useEffect(() => {
        if (isFilterReset) setIsFilterReset(false);
    }, [isFilterReset]);

    const {
        alertMsgDisplay, setAlertMsg
    } = useAlertMessage(props);

    const {
        setIsModalVisible: setIsDeleteModalVisible,
        deleteModalDisplay
    } = useDeleteDebitNote({
        ...props,
        selectedDebitNotes
    });

    const {
        tableActions: tableActions_unposted,
        mainTableActionDetails: mainTableActionDetails_unposted,
        tabDetails: tabDetails_unposted,
        filters: filters_unposted,

        postDebitNoteModal, 
    } = useUnpostedDebitNote({
        ...props,
        selectedDebitNotes, setSelectedDebitNotes,
        setIsDeleteModalVisible,
        setAlertMsg
    });

    const {
        tableActions: tableActions_pendingKnockOff,
        mainTableActionDetails: mainTableActionDetails_pendingKnockOff,
        tabDetails: tabDetails_pendingKnockOff,
        filters: filters_pendingKnockOff,
        
        pendingKnockOffModal
    } = usePendingKnockOff({
        ...props,
        selectedDebitNotes, setSelectedDebitNotes,
        setIsDeleteModalVisible,
        setAlertMsg
    });

    const {
        tabDetails: tabDetails_posted,
        filters: filters_delivered,
        tableActions: tableActions_posted
    } = postedDebitNote({
        ...props,
        selectedDebitNotes, setSelectedDebitNotes,
        setIsDeleteModalVisible,
    });

    let isActionMainHidden = false;
    let isActionHidden = false;
    let isActionLoading = false;
    let tableActions = [];
    let mainTableActionDetails = {};
    let mainActionText = "";
    let filters = {}
    switch (currentTabId) {
        case "unposted":
            tableActions = tableActions_unposted;
            mainTableActionDetails = mainTableActionDetails_unposted;
            mainActionText = "Post to SQL";
            filters = filters_unposted;
            isActionLoading = postDebitNote_requesting;
            break;
        case "pendingKnockOff":
            tableActions = tableActions_pendingKnockOff;
            mainTableActionDetails = mainTableActionDetails_pendingKnockOff;
            mainActionText = "Knock Off Credit";
            filters = filters_pendingKnockOff;
            isActionLoading = knockOffCredit_requesting;
            break;
        default:
            isActionMainHidden = true;
            filters = filters_delivered;
            tableActions = tableActions_posted;
            break;        
    }

    let mainTableActionDetails_onClick = func_validation.getObjectPropertyValue(mainTableActionDetails, "onClick");
    let mainTableActionDetails_isDisabled = func_validation.getObjectPropertyValue(mainTableActionDetails, "isDisabled");
    let mainTableActionDetails_icon = func_validation.getObjectPropertyValue(mainTableActionDetails, "icon");
    let mainTableActionDetails_alt = func_validation.getObjectPropertyValue(mainTableActionDetails, "alt");

    let tabsDetails = [tabDetails_unposted, tabDetails_pendingKnockOff, tabDetails_posted];

    // Dropdown Lists
    const {
        comIdList,
        accountCodeList,
        productCodeList,
        documentNumberList,

        filters: getAlldataFilters,
        setIsRenderRequired, isRenderRequired
    } = useDropdownList({
        ...props,
        filters,
    });

    return (
        <div className={"debit-note"}>
            <DashboardLayout
                headerTitle={"Debit Note"}

                bodyClassName={"debit-note__body"}
                body={(
                    <GeneralTable
                        className={"body__table"}
                        columns={debitNoteColumns.getColumns()}
                        data={debitNoteList}
                        minRows={10}

                        getTableData={props.getDebitNote}

                        isTableRefreshRequired={isDebitNoteRecordUpdatedSuccessfully}

                        onRowSelectionChange={setSelectedDebitNotes}

                        onFilterUpdate={(value) => { getAlldataFilters.current = value; setIsRenderRequired(!isRenderRequired); }}

                        topOuterTableHeader={() => alertMsgDisplay}
                        outerTableHeader={() => {
                            return (
                                <div className={"table__header d-flex align-items-center justify-content-between "}>
                                    <div className={"header__title tableHeaderTitle "}>
                                        List
                                    </div>
                                
                                    {isActionHidden? "":(
                                        <div className={"header__action d-flex align-items-center"}>
                                            
                                            {isActionMainHidden? "":(
                                                <div className={"action__main-action-wrapper"}>
                                                    <Button
                                                        className={"main-action-wrapper__main-action tableHeaderButtonPadding d-flex align-items-center"}
                                                        handleOnClick={mainTableActionDetails_onClick}

                                                        isDisabled={mainTableActionDetails_isDisabled}
                                                        isLoading={isActionLoading}
                                                        isDecoration_primaryTransparent isSpinnerColorPrimary
                                                    >
                                                        <>
                                                            <img
                                                                className={"main-action__icon"}
                                                                src={mainTableActionDetails_icon}
                                                                alt={mainTableActionDetails_alt}
                                                            />

                                                            <span className={"main-action__text tableHeaderButtonText "}>{mainActionText}</span>
                                                        </>
                                                    </Button>
                                                </div>
                                            )}

                                            <SubmenuTooltip
                                                menuItems={tableActions}
                                            >
                                                <MoreButton
                                                    className={"action__more-actions"}
                                                    iconClassName={"more-actions__icon"}
                                                />
                                            </SubmenuTooltip>
                                        </div>
                                    )}
                                </div>
                            );
                        }}

                        bottomOuterTableHeader={(outerTableHeader_props) => {
                            const {
                                filterOptions, setFilterOptions
                            } = outerTableHeader_props;

                            return (
                                <div className={"table__table-filter d-flex flex-wrap align-items-center"}>
                                    <MultiFilters
                                        defaultFilterOption={{
                                            label: "COM ID", 
                                            propertyName: "comId",
                                            placeholder: "COM ID",
                                            suggestionList: [{ label: "All", value: "All" }].concat(comIdList),
                                            inputType: "search",
                                            isInputDigitOnly: true
                                        }}
                                        filterOptions={[
                                            {
                                                label: "COM ID", 
                                                propertyName: "comId",
                                                placeholder: "COM ID",
                                                suggestionList: [{ label: "All", value: "All" }].concat(comIdList),
                                                inputType: "search",
                                                isInputDigitOnly: true
                                            },
                                            {
                                                label: "Account Code", 
                                                propertyName: "accountCode",
                                                placeholder: "Account Code",
                                                suggestionList: [{ label: "All", value: "All" }].concat(accountCodeList),
                                                inputType: "search"
                                            },
                                            {
                                                label: "Product Code", 
                                                propertyName: "productCode",
                                                placeholder: "Product Code",
                                                suggestionList: [{ label: "All", value: "All" }].concat(productCodeList),
                                                inputType: "search"
                                            },
                                            {
                                                label: "Reference Document No", 
                                                propertyName: "documentNo",
                                                placeholder: "Reference Document No",
                                                suggestionList: [{ label: "All", value: "All" }].concat(documentNumberList),
                                                inputType: "search"
                                            },
                                            {
                                                label: "Charge Month", 
                                                propertyName_start: "filterFrom",
                                                propertyName_end: "filterTo",
                                                placeholder_start: "Start",
                                                placeholder_end: "End",
                                                inputType: "dateRange"
                                            },
                                        ]}
                                        dropdownPlaceholder={"Select Filter"}
                                        onApplyFilter={(inputFilters) => {
                                            // find matched tab
                                            let defaultFilter = {}
                                            tabsDetails.map((tabObj, idx) => {
                                                if (tabObj?.id === currentTabId) {
                                                    defaultFilter = tabObj?.filters? tabObj?.filters: filters;
                                                }
                                            })
                                            setFilterOptions(isObjectEmpty(inputFilters)? defaultFilter: { ...filterOptions, ...inputFilters});
                                        }}
                                        isResetFromParentRequired={isFilterReset}
                                    />
                                </div>
                            );
                        }}

                        tabsDetails={tabsDetails}
                        onTabIdChange={(tabId) => {
                            setIsFilterReset(true);
                            setCurrentTabId(tabId);
                        }}
                        defaultTabId={currentTabId}
                        defaultFilter={filters}
                        isTabRequired

                        isExpanderRequired

                        isTableDataLoading={getDebitNoteList_requesting}

                        isUsingPagination
                        totalRecords={getTotalCountFromHeader(debitNoteListHeaders)}

                        isColumnResizeable
                        isTableOddRowsDarken
                        isCheckboxRequired
                        isCheckboxColumnFirst
                    />
                )}
            />

            {/* Delete Alert */}
            {deleteModalDisplay}

            {/* Post Debit Note */}
            {postDebitNoteModal}

            {/* Knock Off Credit */}
            {pendingKnockOffModal}
        </div>
    );
}